import { render } from "./CatObjetoView.vue?vue&type=template&id=fe07e016&scoped=true"
import script from "./CatObjetoView.vue?vue&type=script&lang=js"
export * from "./CatObjetoView.vue?vue&type=script&lang=js"

import "./CatObjetoView.vue?vue&type=style&index=0&id=fe07e016&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe07e016"]])

export default __exports__